// The live bridge exposes form operations, never arbitrary JavaScript or persistence.
const invoiceLiveEditorApi = (() => {
  const snapshot = (s: any, layout: string, blocked: boolean) => ({
    blocked: Boolean(blocked || !['faktura', 'tilbud', 'ordre'].includes(s.docType) || (s.sourceDraftNum && !s.sourceDraftId)), layout,
    documentType: s.docType,
    customerEmail: s.customer?.email || '', customerId: s.customer?.id || '', customerName: s.customer?.name || '',
    invoiceDate: s.invDate || '', dueDate: s.dueDate || '', comment: s.comment || '',
    lines: s.lines.map((l: any) => ({ productId: l.productId || '', description: l.desc || '',
      quantity: Number(l.qty), unitPrice: window.PlummeMoneyInput.number(l.price, 0), vatSelection: String(l.vat),
    })),
  })
  const perform = (host: any, step: any) => {
    const s = host.editor()
    if (host.blocked() || !['faktura', 'tilbud', 'ordre'].includes(s.docType) || s.repeating || s.customer?.isList || (s.sourceDraftNum && !s.sourceDraftId)) throw new Error('control.advancedInvoice')
    const view = () => snapshot(host.editor(), host.layout(), host.blocked())
    if (step.action === 'set_document_type') {
      if (!['faktura', 'tilbud', 'ordre'].includes(step.documentType) || s.sourceDraftId || s.customer || s.lines.some((l: any) => String(l.desc || '').trim())) throw new Error('listControl.unsaved')
      s.setDocType(step.documentType)
      return () => view().documentType === step.documentType
    }
    if (step.action === 'set_customer') {
      const customer = host.customers().find((c: any) => c.id === step.customerId)
      if (!customer) throw new Error('control.customerRequired')
      host.present('customer'); s.setCustomer(customer); s.setCustEnabled(true)
      return () => view().customerId === customer.id
    }
    if (step.action === 'set_field') {
      const setters: any = { invoiceDate: s.setInvDate, dueDate: s.setDueDate, comment: s.setComment }
      if (!setters[step.field] || typeof step.value !== 'string' || step.value.length > 4000) throw new Error('control.invoiceOnly')
      if (step.field !== 'comment' && (!/^\d{4}-\d{2}-\d{2}$/.test(step.value) || !Number.isFinite(Date.parse(step.value)) || new Date(step.value).toISOString().slice(0, 10) !== step.value)) throw new Error('control.failed')
      host.present('details'); setters[step.field](step.value)
      return () => (view() as any)[step.field] === step.value
    }
    if (!['set_line', 'remove_line'].includes(step.action)) throw new Error('control.invoiceOnly')
    const index = step.lineIndex
    if (!Number.isInteger(index) || index < 0 || index > s.lines.length || index > 99) throw new Error('control.failed')
    const previous = s.lines[index]
    if (previous && ((previous.lineType && previous.lineType !== 'product') || previous.rentalPricing?.enabled || previous.subStart)) throw new Error('control.advancedInvoice')
    if (step.action === 'remove_line') {
      if (!previous) throw new Error('control.failed')
      const lines = s.lines.filter((_: any, i: number) => i !== index)
      if (!lines.length) throw new Error('control.incomplete')
      host.present('lines'); s.setLines(lines)
      return () => host.editor().lines.length === lines.length && !host.editor().lines.some((l: any) => l.id === previous.id)
    }
    const input = step.line || {}
    let productPatch: any = {}
    if (input.productId) {
      const product = host.products().find((p: any) => p.id === input.productId)
      if (!product) throw new Error('control.productRequired')
      if (['Utleie', 'Abonnement'].includes(product.type)) throw new Error('control.advancedInvoice')
      productPatch = host.productPatch(product)
    }
    const next = { ...(previous || { id: crypto.randomUUID(), lineType: 'product', qty: 1, price: 0, disc: 0 }), ...productPatch }
    if (input.description !== undefined) {
      if (typeof input.description !== 'string' || !input.description.trim() || input.description.length > 4000) throw new Error('control.failed')
      next.desc = input.description
    }
    for (const [source, target] of [['quantity', 'qty'], ['unitPrice', 'price']]) {
      if (input[source] !== undefined) {
        if (typeof input[source] !== 'number' || !Number.isFinite(input[source]) || input[source] < 0 || (source === 'quantity' && input[source] === 0)) throw new Error('control.failed')
        next[target] = input[source]
      }
    }
    if (input.vatSelection !== undefined) {
      if (!host.vatOptions().some((v: any) => String(v.value) === input.vatSelection)) throw new Error('control.advancedInvoice')
      // Product account/tax metadata must be changed in the product editor.
      if (next.productId && input.vatSelection !== String(next.vat)) throw new Error('control.advancedInvoice')
      next.vat = input.vatSelection
    }
    if (!next.desc || next.vat === undefined) throw new Error('control.incomplete')
    const lines = [...s.lines]; lines[index] = next
    host.present('lines'); s.setLines(lines)
    const expected = JSON.stringify(next)
    return () => JSON.stringify(host.editor().lines[index]) === expected
  }
  const highlight = (step: any) => {
    const section = step.action === 'set_customer' ? 'customer' : step.action === 'set_field' ? 'details' : ['set_line', 'remove_line'].includes(step.action) ? 'lines' : ''
    if (!section) return
    const node = document.querySelector(`.invoice-live-${section}`)
    if (!node) return
    node.scrollIntoView({ block: 'center', behavior: 'smooth' })
    node.classList.remove('invoice-live-highlight')
    requestAnimationFrame(() => node.classList.add('invoice-live-highlight'))
    setTimeout(() => node.classList.remove('invoice-live-highlight'), 1500)
  }
  return { snapshot, perform, highlight }
})()
Object.assign(globalThis, { PlummeInvoiceLiveEditor: invoiceLiveEditorApi })
